import { useNavigate } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { EventsController } from "./events-controller";
import { EventsPage } from "./events-page";

export function EventsRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  return (
    <Subtree
      key="events"
      controller={() =>
        new EventsController(
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "locationsRepository",
            "capabilitiesRepository",
            "stripePayments",
            "shareLinks",
          ),
          {
            toNew: () => navigate("/events/new"),
            toShow: (eventId) => navigate(`/events/${eventId}`),
          },
        )
      }
    >
      <EventsPage />
    </Subtree>
  );
}
